/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios';
import { getEnv } from '../utils/env';

const MS_DEVICE_VIEW_BASE_URL = `${getEnv('MS_DEVICE_VIEW')}/`;
const MCS_DEVICE_URL_BASE_URL = `${getEnv('MCS_DEVICE_URL')}/`;

// Helper function to validate URLs
export function validateUrl(url) {
  try {
    const parsedUrl = new URL(url);
    const allowedHosts = [
      new URL(MS_DEVICE_VIEW_BASE_URL).host,
      new URL(MCS_DEVICE_URL_BASE_URL).host
    ];

    if (!allowedHosts.includes(parsedUrl.host)) {
      throw new Error(`Invalid host: ${parsedUrl.host}`);
    }
  } catch (error) {
    console.error('URL validation failed:', error.message);
    throw new Error('Invalid URL');
  }
}

const isUserSwitched = () => {
  const isUserSwitched = localStorage.getItem('resumeUserEmail') ? true : false;
  return isUserSwitched;
};

// Helper function to add partner ID to URL if user is a partner user
export function addPartnerIdToUrl(url) {
  try {
    const userContext = JSON.parse(localStorage.getItem('userContext'));
    if (userContext?.isPartnerUser) {
      const partnerContext = localStorage.getItem('partnerContext');
      if (partnerContext) {
        const partnerId = JSON.parse(partnerContext)._id;
        return `${url}&partnerId=${partnerId}`;
      }
    }
    return url;
  } catch (error) {
    console.error('Error adding partner ID to URL:', error);
    return url;
  }
}

export async function getCustomerAggregateData(
  apiRoute,
  customerContext,
  type,
  property,
  startDate,
  endDate
) {
  try {
    const token = JSON.parse(localStorage.getItem('jshellAuthToken')).token;
    const businessModel = localStorage.getItem('businessModel') || 'MPS';
    const userContext = JSON.parse(localStorage.getItem('userContext'));

    let MS_DCC_URL = `${MS_DEVICE_VIEW_BASE_URL}${apiRoute}?asset=${'MSCC'}&businessModel=${businessModel}&cogId=${encodeURIComponent(customerContext.customerOpportunityGroupId)}`;

    if (property) {
      MS_DCC_URL += `&property=${encodeURIComponent(property)}`;
    }
    if (type) {
      MS_DCC_URL += `&type=${encodeURIComponent(type)}`;
    }
    if (startDate) {
      MS_DCC_URL += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate) {
      MS_DCC_URL += `&endDate=${encodeURIComponent(endDate)}`;
    }

    // Add partner ID if user is a partner user
    MS_DCC_URL = addPartnerIdToUrl(MS_DCC_URL);

    // Validate the constructed URL
    validateUrl(MS_DCC_URL);

    const response = await axios.get(MS_DCC_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        ...(isUserSwitched() && {
          switchedUserUniqueId: userContext?.dbUserId
        })
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error in getCustomerAggregateData: ', error);
    throw error;
  }
}

export async function updateUserWidgetPreference(widgetArray, dashboardtype) {
  try {
    const token = JSON.parse(localStorage.getItem('jshellAuthToken')).token;
    const businessModel = localStorage.getItem('businessModel') || 'MPS';
    const userContext = JSON.parse(localStorage.getItem('userContext'));
    const MS_DCC_URL = `${MS_DEVICE_VIEW_BASE_URL}updateWidgetPreferenceByUserId?asset=${'MSCC'}&businessModel=${businessModel}`;

    // Validate the URL
    validateUrl(MS_DCC_URL);

    const body = {
      dashboardCategory: dashboardtype,
      updatedWidgetPreference: widgetArray
    };

    const response = await axios.put(MS_DCC_URL, body, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        ...(isUserSwitched() && {
          switchedUserUniqueId: userContext?.dbUserId
        })
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error in updateUserWidgetPreference: ', error);
    throw error;
  }
}

export async function getBreadcrumbAggregates() {
  try {
    const token = JSON.parse(localStorage.getItem('jshellAuthToken')).token;
    const userContext = JSON.parse(localStorage.getItem('userContext'));
    const sessionStorageCustomerContext =
      sessionStorage.getItem('customerContext');
    const localStorageCustomerContext = localStorage.getItem('customerContext');
    const sessionStorageCogId = sessionStorageCustomerContext
      ? JSON.parse(sessionStorageCustomerContext).customerOpportunityGroupId
      : null;
    const localStorageCogId = localStorageCustomerContext
      ? JSON.parse(localStorageCustomerContext).customerOpportunityGroupId
      : null;
    const customerId = userContext?.isPartnerUser
      ? sessionStorageCogId
      : localStorageCogId || '{}';

    const businessModel = localStorage.getItem('businessModel') || 'MPS';

    let MS_DCC_URL = `${MS_DEVICE_VIEW_BASE_URL}getBreadcrumbAggregates?cogId=${encodeURIComponent(
      customerId
    )}&asset=${'MSCC'}&businessModel=${businessModel}`;

    // Add partner ID if user is a partner user
    MS_DCC_URL = addPartnerIdToUrl(MS_DCC_URL);

    // Validate the URL
    validateUrl(MS_DCC_URL);

    const response = await axios.get(MS_DCC_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        ...(isUserSwitched() && {
          switchedUserUniqueId: userContext?.dbUserId
        })
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error in getBreadcrumbAggregates: ', error);
    throw error;
  }
}

export async function refreshSupplyOrderData() {
  try {
    const token = JSON.parse(localStorage.getItem('jshellAuthToken')).token;
    const userContext = JSON.parse(localStorage.getItem('userContext'));
    const sessionStorageCustomerContext =
      sessionStorage.getItem('customerContext');
    const localStorageCustomerContext = localStorage.getItem('customerContext');
    const sessionStorageCogId = sessionStorageCustomerContext
      ? JSON.parse(sessionStorageCustomerContext).customerOpportunityGroupId
      : null;
    const localStorageCogId = localStorageCustomerContext
      ? JSON.parse(localStorageCustomerContext).customerOpportunityGroupId
      : null;
    const customerId = userContext?.isPartnerUser
      ? sessionStorageCogId
      : localStorageCogId || '{}';
    const businessModel = localStorage.getItem('businessModel') || 'MPS';
    const MS_DCC_URL = `${MS_DEVICE_VIEW_BASE_URL}fetchOpenSupplyOrderFromARC?scheduleCron=true&customerOpportunityGroupId=${encodeURIComponent(
      customerId
    )}&asset=${'MSCC'}&businessModel=${businessModel}&cogId=${encodeURIComponent(
      customerId
    )}`;
    // Validate the URL
    validateUrl(MS_DCC_URL);

    const response = await axios.get(MS_DCC_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        ...(isUserSwitched() && {
          switchedUserUniqueId: userContext?.dbUserId
        })
      }
    });
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getCustomerAggregateDataForMCS(
  apiRoute,
  customerContext,
  type,
  property
) {
  try {
    const token = JSON.parse(localStorage.getItem('jshellAuthToken')).token;
    const businessModel = localStorage.getItem('businessModel') || 'MPS';
    const userContext = JSON.parse(localStorage.getItem('userContext'));

    let MS_DCC_URL = `${MCS_DEVICE_URL_BASE_URL}${apiRoute}?asset=${'MSCC'}&businessModel=${businessModel}&cogId=${encodeURIComponent(customerContext.customerOpportunityGroupId)}`;

    // if (apiRoute === 'customer/openServices') {
    //   MS_DCC_URL = `${MCS_DEVICE_URL_BASE_URL}${apiRoute}?asset=${'MSCC'}&businessModel=${businessModel}&cogId=${encodeURIComponent(customerContext.customerOpportunityGroupId)}`;
    // }

    if (property) {
      MS_DCC_URL += `&property=${encodeURIComponent(property)}`;
    }
    if (type) {
      MS_DCC_URL += `&type=${encodeURIComponent(type)}`;
    }

    // Add partner ID if user is a partner user
    MS_DCC_URL = addPartnerIdToUrl(MS_DCC_URL);

    // Validate the constructed URL
    validateUrl(MS_DCC_URL);

    const response = await axios.get(MS_DCC_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        ...(isUserSwitched() && {
          switchedUserUniqueId: userContext?.dbUserId
        })
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error in getCustomerAggregateDataForMCS: ', error);
    throw error;
  }
}

export async function geMCSDahboardAggregatesData(
  apiRoute,
  customerContext,
  type,
  property
) {
  try {
    const token = JSON.parse(localStorage.getItem('jshellAuthToken')).token;
    // const customerId = customerContext._id;
    const businessModel = localStorage.getItem('businessModel') || 'MPS';
    const userContext = JSON.parse(localStorage.getItem('userContext'));

    let MS_DCC_URL = `${MS_DEVICE_VIEW_BASE_URL}${apiRoute}?asset=${'MSCC'}&businessModel=${businessModel}&cogId=${encodeURIComponent(customerContext.customerOpportunityGroupId)}`;

    // if (apiRoute === 'customer/openServices') {
    //   MS_DCC_URL = `${MS_DEVICE_VIEW_BASE_URL}${apiRoute}?asset=${'MSCC'}&businessModel=${businessModel}&cogId=${encodeURIComponent(customerContext.customerOpportunityGroupId)}`;
    // }

    if (property) {
      MS_DCC_URL += `&property=${encodeURIComponent(property)}`;
    }
    if (type) {
      MS_DCC_URL += `&type=${encodeURIComponent(type)}`;
    }

    // Add partner ID if user is a partner user
    MS_DCC_URL = addPartnerIdToUrl(MS_DCC_URL);

    // Validate the constructed URL
    validateUrl(MS_DCC_URL);

    const response = await axios.get(MS_DCC_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        ...(isUserSwitched() && {
          switchedUserUniqueId: userContext?.dbUserId
        })
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error in geMCSDahboardAggregatesData: ', error);
    throw error;
  }
}

export async function getUserSession() {
  try {
    const token = JSON.parse(localStorage.getItem('jshellAuthToken')).token;
    const businessModel = localStorage.getItem('businessModel') || 'MPS';
    const userContext = JSON.parse(localStorage.getItem('userContext'));

    const MS_DCC_URL = `${MS_DEVICE_VIEW_BASE_URL}userSession?asset=${'MSCC'}&businessModel=${businessModel}`;

    // Validate the URL
    validateUrl(MS_DCC_URL);

    const response = await axios.get(MS_DCC_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        ...(isUserSwitched() && {
          switchedUserUniqueId: userContext?.dbUserId
        })
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error in getUserSession: ', error);
    throw error;
  }
}
export { getEnv };
